import { Empty, Loaded, Loading } from 'stores/core';
import { Memberships } from './memberships';
const EMPTY = {
    byProjectId: {},
    projects: []
};
export const MembershipsStore = {
    empty: ()=>EMPTY,
    setLoading: ([, projectId])=>({ byProjectId, projects })=>({
                projects: projects.filter((x)=>x !== projectId).concat(projectId),
                byProjectId: {
                    ...byProjectId,
                    [projectId]: Loading()
                }
            }),
    load: ([, projectId], memberships, placeholders)=>({ byProjectId, projects })=>({
                projects: projects.filter((x)=>x !== projectId).concat(projectId),
                byProjectId: {
                    ...byProjectId,
                    [projectId]: Loaded(memberships.reduce((membership, { userId, memberType, joinedAt })=>Memberships.set(userId, memberType, joinedAt)(membership), {
                        ...Memberships.empty(),
                        placeholders
                    }))
                }
            }),
    add: ([, projectId], memberships)=>({ byProjectId, projects })=>{
            var _byProjectId_projectId;
            const [, initial = Memberships.empty()] = (_byProjectId_projectId = byProjectId[projectId]) !== null && _byProjectId_projectId !== void 0 ? _byProjectId_projectId : Empty();
            return {
                projects: projects.filter((x)=>x !== projectId).concat(projectId),
                byProjectId: {
                    ...byProjectId,
                    [projectId]: Loaded(memberships.reduce((membership, { userId, memberType, joinedAt })=>Memberships.set(userId, memberType, joinedAt)(membership), initial))
                }
            };
        },
    remove: ([, projectId], userIds)=>({ byProjectId, projects })=>{
            var _byProjectId_projectId;
            const [, initial = Memberships.empty()] = (_byProjectId_projectId = byProjectId[projectId]) !== null && _byProjectId_projectId !== void 0 ? _byProjectId_projectId : Empty();
            return {
                projects: projects.filter((x)=>x !== projectId).concat(projectId),
                byProjectId: {
                    ...byProjectId,
                    [projectId]: Loaded(userIds.reduce((membership, userId)=>Memberships.reset(userId)(membership), initial))
                }
            };
        },
    ofProject: ([, projectId])=>({ byProjectId })=>{
            var _byProjectId_projectId;
            return (_byProjectId_projectId = byProjectId[projectId]) !== null && _byProjectId_projectId !== void 0 ? _byProjectId_projectId : Memberships.empty();
        },
    addProjectPlaceholder: ([, projectId], team)=>(state)=>{
            var _byProjectId_projectId, _ref;
            var _initial_placeholders;
            const { byProjectId } = state;
            const [, initial = Memberships.empty()] = (_byProjectId_projectId = byProjectId[projectId]) !== null && _byProjectId_projectId !== void 0 ? _byProjectId_projectId : Empty();
            return {
                ...state,
                byProjectId: {
                    ...byProjectId,
                    [projectId]: Loaded({
                        ...initial,
                        placeholders: [
                            ...(_ref = (_initial_placeholders = initial.placeholders) === null || _initial_placeholders === void 0 ? void 0 : _initial_placeholders.filter(({ teamId })=>team.teamId !== teamId)) !== null && _ref !== void 0 ? _ref : [],
                            team
                        ]
                    })
                }
            };
        },
    updateProjectPlaceholder: ([, projectId], team)=>(state)=>{
            var _byProjectId_projectId, _ref;
            var _initial_placeholders;
            const { byProjectId } = state;
            const [, initial = Memberships.empty()] = (_byProjectId_projectId = byProjectId[projectId]) !== null && _byProjectId_projectId !== void 0 ? _byProjectId_projectId : Empty();
            return {
                ...state,
                byProjectId: {
                    ...byProjectId,
                    [projectId]: Loaded({
                        ...initial,
                        placeholders: [
                            ...(_ref = (_initial_placeholders = initial.placeholders) === null || _initial_placeholders === void 0 ? void 0 : _initial_placeholders.filter(({ teamId })=>teamId !== team.teamId)) !== null && _ref !== void 0 ? _ref : [],
                            team
                        ]
                    })
                }
            };
        },
    removeProjectPlaceholder: ([, projectId], teamId)=>(state)=>{
            var _byProjectId_projectId, _ref;
            var _initial_placeholders;
            const { byProjectId } = state;
            const [, initial = Memberships.empty()] = (_byProjectId_projectId = byProjectId[projectId]) !== null && _byProjectId_projectId !== void 0 ? _byProjectId_projectId : Empty();
            return {
                ...state,
                byProjectId: {
                    ...byProjectId,
                    [projectId]: Loaded({
                        ...initial,
                        placeholders: (_ref = (_initial_placeholders = initial.placeholders) === null || _initial_placeholders === void 0 ? void 0 : _initial_placeholders.filter((team)=>team.teamId !== teamId)) !== null && _ref !== void 0 ? _ref : []
                    })
                }
            };
        }
};
